import React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import CircularProgress from '@mui/material/CircularProgress';
import { useState } from "react";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import StudentDetails from "./BookingDetails/StudentDetails";
import CenterSelection from "./BookingDetails/CenterSelection";
import ParentDetails from "./BookingDetails/ParentDetails";
import CourseDetails from "./BookingDetails/CourseDetails";
import HealthDetails from "./BookingDetails/HealthDetails";
import TransportDetails from "./BookingDetails/TransportDetails";
import FinishDetails from "./BookingDetails/FinishDetails";
import PricingDetailsArray from "./BookingDetails/PricingDetailsArray";

import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { getCenters } from "../../actions/center";
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import { toast } from "react-toastify";
import "./Booking.css";
import { yellow } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import * as dayjs from "dayjs";
import { upsertBooking } from "../../actions/booking";
import Backdrop from '@mui/material/Backdrop';
import { trainingPrograms } from "./BookingDetails/trainingPrograms";

const Booking = () => {

  const dispatch = useDispatch();

  const { user: currentUser } = useSelector((state) => state.auth);

  const { centers: listCenters } = useSelector((state) => state.centers);
  let centerLoaded = false;
  useEffect(() => {
    if (!centerLoaded) {
      dispatch(getCenters()).then(() => {
        centerLoaded = true;
      }).catch(() => {
        setLoading(false);
      })
    }
  }, []);

  const handleSelectedCenterChange = (center) => {
    setSelectedCenter(center);
  }

  const [isFormInvalid, setIsFormInvalid] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  //Student details
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [email, setEmail] = useState(null);
  const [passport, setPassport] = useState(null);
  const [gender, setGender] = useState(0);
  const [nationality, setNationality] = useState(null);
  const [birthDate, setBirthDate] = useState(null);
  const [motherTongue, setMotherTongue] = useState(null);
  const [address, setAddress] = useState(null);
  const [address2, setAddress2] = useState(null);
  const [address3, setAddress3] = useState(null);
  const [country, setCountry] = useState(null);
  const [locality, setLocality] = useState(null);
  const [zip_code, setZipCode] = useState(null);
  const [phone, setPhone] = useState(null);
  const [countryName, setCountryName] = useState(null);

  //Your center
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [arrivalDeparture, setArrivalDeparture] = useState([new Date(`${new Date().getFullYear()}-07-01`), null]);
  const [ageGroup, setAgeGroup] = useState(0);
  const [extras, setExtras] = useState([]);
  const [weeks, setWeeks] = useState([]);

  // Parent details
  const [motherName, setMotherName] = useState(null);
  const [motherEmail, setMotherEmail] = useState(null);
  const [motherOccupation, setMotherOccupation] = useState(null);
  const [motherPhone, setMotherPhone] = useState(null);
  const [fatherName, setFatherName] = useState(null);
  const [fatherEmail, setFatherEmail] = useState(null);
  const [fatherOccupation, setFatherOccupation] = useState(null);
  const [fatherPhone, setFatherPhone] = useState(null);
  const [unsupervisedFreeTime, setUnsupervisedFreeTime] = useState(null);

  //Pictures
  const [profilePicture, setProfilePicture] = useState(null);
  const [passportPicture, setPassportPicture] = useState(null);

  // Health details
  const [asthmaOrBronchitis, setAsthmaOrBronchitis] = useState(null);
  const [fitsFaintingBlack, setFitsFaintingBlack] = useState(null);
  const [heartCondition, setHeartCondition] = useState(null);
  const [severeHeadaches, setSevereHeadaches] = useState(null);
  const [diabetes, setDiabetes] = useState(null);
  const [allergiesToKnownMedicines, setAllergiesToKnownMedicines] = useState(null);
  const [otherAllergies, setOtherAllergies] = useState(null);
  const [travelSickness, setTravelSickness] = useState(null);
  const [bedwettingIncontinence, setBedwettingIncontinence] = useState(null);
  const [anyMentalHealthProblems, setAnyMentalHealthProblems] = useState(null);
  const [regularMedication, setRegularMedication] = useState(null);
  const [regularHospitalTreatment, setRegularHospitalTreatment] = useState(null);
  const [anyMedicationPring, setAnyMedicationPring] = useState(null);
  const [anythingElse, setAnyThingElse] = useState(null);
  const [moreDetails, setMoreDetails] = useState(null);
  const [agreeNonPrescription, setAgreeNonPrescription] = useState(null);
  const [arrangeMedicalTreatment, setArrangeMedicalTreatment] = useState(null);
  const [roomingComment, setRoomingComment] = useState(null);

  //Transport details
  const [departureAirport, setDepartureAirport] = useState(null)
  const [departureFlightNumber, setDepartureFlightNumber] = useState(null);
  const [departureUmService, setDepartureUmService] = useState(null);
  const [departureTransfer, setDepartureTransfer] = useState(null);
  const [departureHour, setDepartureHour] = useState(null);
  const [departureTerminal, setDepartureTerminal] = useState(null);

  const [arrivalAirport, setArrivalAirport] = useState(null)
  const [arrivalFlightNumber, setArrivalFlightNumber] = useState(null);
  const [arrivalUmService, setArrivalUmService] = useState(null);
  const [arrivalTransfer, setArrivalTransfer] = useState(null);
  const [arrivalHour, setArrivalHour] = useState(null);
  const [arrivalTerminal, setArrivalTerminal] = useState(null);

  const [arrivalComment, setArrivalComment] = useState(null);
  const [departureComment, setDepartureComment] = useState(null);

  //Signature
  const [signatureFilled, setSignatureFilled] = useState(null);
  const [signatureBytes, setSignatureBytes] = useState([])


  //Pricing
  const [total_discount, setTotalDiscount] = useState(0);
  const [total_commission, setTotalCommission] = useState(0);

  const [total_journey, setTotalJourney] = useState(0);
  const [total_extra, setTotalExtra] = useState(0);
  const [total_extra_days, setTotalExtraDays] = useState(0);
  const [total_um, setTotalUM] = useState(0);
  const [total_transport, setTotalTransport] = useState(0);
  const [total, setTotal] = useState(0);
  const [balance, setBalance] = useState(0);
  const [comment, setComment] = useState(null)


  const [sending_booking, setSendingBooking] = useState(false)

  const [loading, setLoading] = React.useState(false);
  const handleClose = () => {
    setLoading(false);
  };
  const handleToggle = () => {
    setLoading(!loading);
  };

  const getAge = (DOB) => {
    var today = new Date();
    var birthDate = new Date(DOB);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  const steps = [
    {
      label: "Your centre",
      component:
        <CenterSelection
          listCenters={listCenters}
          selectedCenterValue={selectedCenter} setSelectedCenter={handleSelectedCenterChange}
          ageGroup={ageGroup} setAgeGroup={setAgeGroup}
          arrivalDeparture={arrivalDeparture} setArrivalDeparture={setArrivalDeparture}
          setExtras={handleExtrasChange}
          setWeeks={handleWeeksChange}
          isFormInvalid={isFormInvalid} />,
      isValid: () => {
        return selectedCenter
      },
    },
    {
      label: "Student details",
      component:
        <StudentDetails
          setFirstName={setFirstName} firstNameValue={firstName}
          setLastName={setLastName} lastNameValue={lastName}
          setGender={setGender} genderValue={gender}
          setNationality={setNationality} nationalityValue={nationality}
          setAddress={setAddress} addressValue={address}
          setAddress2={setAddress2} address2Value={address2}
          setCountry={setCountry} countryValue={country}
          setLocality={setLocality} localityValue={locality}
          setBirthDate={setBirthDate} birthDateValue={birthDate}
          setMotherTongue={setMotherTongue} motherTongueValue={motherTongue}
          setEmail={setEmail} emailValue={email}
          setPassport={setPassport} passportValue={passport}
          setAddress3={setAddress3} address3Value={address3}
          setZipCode={setZipCode} zipCodeValue={zip_code}
          setAgeGroup={setAgeGroup} ageGroup={ageGroup}
          setPhone={setPhone} phone={phone}
          isFormInvalid={isFormInvalid}
          setCountryName={setCountryName}
          center={selectedCenter}
          profilePicture={profilePicture}
          setProfilePicture={setProfilePicture}
          passportPicture={passportPicture}
          setPassportPicture={setPassportPicture} />,
      isValid: () => {
        return validateFields(lastName, firstName, passport, phone) && (ageGroup != null)
      },
    },
    {
      label: "Course details",
      component:
        <CourseDetails
          setAgeGroup={setAgeGroup}
          ageGroup={ageGroup}
          arrivalDeparture={arrivalDeparture}
          setArrivalDeparture={setArrivalDeparture}
          extras={extras}
          setExtras={handleExtrasChange}
          selectedCenterValue={selectedCenter}
          isFormInvalid={isFormInvalid}
          weeks={weeks} setWeeks={handleWeeksChange}
          setTotalJourney={setTotalJourney}
          center={selectedCenter}
          birthDate={birthDate}
        />,
      isValid: () => {
        return (weeks.length > 0 && ageGroup != null && ageGroup != -1)
      },
    },
    {
      label: "Parent/Guardian details",
      component:
        <ParentDetails
          setMotherName={setMotherName} motherNameValue={motherName}
          setMotherEmail={setMotherEmail} motherEmailValue={motherEmail}
          setMotherOccupation={setMotherOccupation} motherOccupationValue={motherOccupation}
          setFatherName={setFatherName} fatherNameValue={fatherName}
          setFatherEmail={setFatherEmail} fatherEmailValue={fatherEmail}
          setFatherOccupation={setFatherOccupation} fatherOccupationValue={fatherOccupation}
          setMotherPhone={setMotherPhone} motherPhone={motherPhone}
          setFatherPhone={setFatherPhone} fatherPhone={fatherPhone}
          setUnsupervisedFreeTime={setUnsupervisedFreeTime} unsupervisedFreeTime={unsupervisedFreeTime}
          isFormInvalid={isFormInvalid} />,
      isValid: () => {
        return (motherName && fatherName) && (motherPhone && fatherPhone && unsupervisedFreeTime)
      },
    },
    {
      label: "Health details",
      component:
        <HealthDetails
          setAsthmaOrBronchitis={setAsthmaOrBronchitis} asthmaOrBronchitisValue={asthmaOrBronchitis}
          setFitsFaintingBlack={setFitsFaintingBlack} fitsFaintingBlackValue={fitsFaintingBlack}
          setHeartCondition={setHeartCondition} heartConditionValue={heartCondition}
          setSevereHeadaches={setSevereHeadaches} severeHeadachesValue={severeHeadaches}
          setDiabetes={setDiabetes} diabetesValue={diabetes}
          setAllergiesToKnownMedicines={setAllergiesToKnownMedicines} allergiesToKnownMedicinesValue={allergiesToKnownMedicines}
          setOtherAllergies={setOtherAllergies} otherAllergiesValue={otherAllergies}
          setTravelSickness={setTravelSickness} travelSicknessValue={travelSickness}
          setBedwettingIncontinence={setBedwettingIncontinence} bedwettingIncontinenceValue={bedwettingIncontinence}
          setAnyMentalHealthProblems={setAnyMentalHealthProblems} anyMentalHealthProblemsValue={anyMentalHealthProblems}
          setRegularMedication={setRegularMedication} regularMedicationValue={regularMedication}
          setRegularHospitalTreatment={setRegularHospitalTreatment} regularHospitalTreatmentValue={regularHospitalTreatment}
          setAnyMedicationPring={setAnyMedicationPring} anyMedicationPringValue={anyMedicationPring}
          setAnyThingElse={setAnyThingElse} anythingElseValue={anythingElse}
          setMoreDetails={setMoreDetails} moreDetailsValue={moreDetails}
          setAgreeNonPrescription={setAgreeNonPrescription} agreeNonPrescriptionValue={agreeNonPrescription}
          setArrangeMedicalTreatment={setArrangeMedicalTreatment} arrangeMedicalTreatmentValue={arrangeMedicalTreatment}
          setRoomingComment={setRoomingComment} roomingComment={roomingComment}
          isFormInvalid={isFormInvalid} />,
      isValid: () => {
        return asthmaOrBronchitis && fitsFaintingBlack && heartCondition && severeHeadaches && diabetes && allergiesToKnownMedicines
          && otherAllergies && travelSickness && bedwettingIncontinence && anyMentalHealthProblems && regularMedication
          && anyMedicationPring && anythingElse && agreeNonPrescription && arrangeMedicalTreatment
      },
    },
    {
      label: "Transport details",
      component:
        <TransportDetails
          selectedCenter={selectedCenter}
          arrivalAirport={arrivalAirport} setArrivalAirport={setArrivalAirport}
          arrivalFlightNumber={arrivalFlightNumber} setArrivalFlightNumber={setArrivalFlightNumber}
          arrivalUmService={arrivalUmService} setArrivalUmService={handleArrivalUmChange}
          arrivalTransfer={arrivalTransfer} setArrivalTransfer={handleArrivalTransferChange}
          arrivalHour={arrivalHour} setArrivalHour={setArrivalHour}
          arrivalTerminal={arrivalTerminal} setArrivalTerminal={setArrivalTerminal}

          departureAirport={departureAirport} setDepartureAirport={setDepartureAirport}
          departureFlightNumber={departureFlightNumber} setDepartureFlightNumber={setDepartureFlightNumber}
          departureUmService={departureUmService} setDepartureUmService={handleDepartureUmChange}
          departureTansfer={departureTransfer} setDepartureTransfer={handleDepartureTransferChange}
          departureHour={departureHour} setDepartureHour={setDepartureHour}
          departureTerminal={departureTerminal} setDepartureTerminal={setDepartureTerminal}
          isFormInvalid={isFormInvalid}
          arrivalComment={arrivalComment} setArrivalComment={setArrivalComment}
          departureComment={departureComment} setDepartureComment={setDepartureComment}
        />,
      isValid: () => {
        return arrivalUmService != null && departureUmService != null && departureTransfer != null && arrivalTransfer != null
      },
    },
    {
      label: "Signature",
      component:
        <FinishDetails
          setSignatureFilled={setSignatureFilled}
          isFormInvalid={isFormInvalid}
          setSignatureBytes={setSignatureBytes}
          signatureBytes={signatureBytes}
          signatureFilled={signatureFilled}
          comment={comment} setComment={setComment} />,
      isValid: () => { return signatureFilled },
    },
  ];

  const validateFields = (...strings) => {
    let is_valid = true;
    strings.forEach((s) => {
      if (s == null || s == '') {
        is_valid = false
      }
    });
    return is_valid;
  }


  const handleStep = (step) => () => {
    if (activeStep != steps.length || true) {
      setActiveStep(step);
    }
  };

  const handleNext = () => {
    if (steps[activeStep].isValid()) {
      setIsFormInvalid(false);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      if (activeStep == 6) {
        if (handleSubmit()) {
          //handleReset();
        }
      }
    } else {
      setIsFormInvalid(true);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {

    //Center
    setSelectedCenter(null);
    setExtras([]);
    setWeeks([]);

    //Student
    setFirstName(null);
    setLastName(null);
    setEmail(null);
    setPassport(null);
    setGender(null);
    setNationality(null);
    setBirthDate(null);
    setMotherTongue(null);
    setAddress(null);
    setAddress2(null);
    setAddress3(null);
    setCountry(null);
    setLocality(null);
    setZipCode(null);
    setAgeGroup(null)
    //Parents
    setMotherName(null);
    setMotherEmail(null);
    setMotherPhone(null);
    setMotherOccupation(null);
    setFatherName(null);
    setFatherEmail(null);
    setFatherPhone(null);
    setFatherOccupation(null);
    //Health
    setAsthmaOrBronchitis(null);
    setFitsFaintingBlack(null);
    setHeartCondition(null);
    setSevereHeadaches(null);
    setDiabetes(null);
    setAllergiesToKnownMedicines(null);
    setOtherAllergies(null);
    setTravelSickness(null);
    setBedwettingIncontinence(null);
    setAnyMentalHealthProblems(null);
    setRegularMedication(null);
    setRegularHospitalTreatment(null);
    setAnyMedicationPring(null);
    setAnyThingElse(null);
    setMoreDetails(null);
    setAgreeNonPrescription(null);
    setArrangeMedicalTreatment(null);
    //Transport
    setDepartureAirport(null)
    setDepartureFlightNumber(null);
    setDepartureUmService(null);
    setDepartureTransfer(null);
    setDepartureHour(null);
    setDepartureTerminal(null);
    setArrivalAirport(null)
    setArrivalFlightNumber(null);
    setArrivalUmService(null);
    setArrivalTransfer(null);
    setArrivalHour(null);
    setArrivalTerminal(null);

    setTotalUM(0)
    setTotalJourney(0)
    setTotalExtra(0)
    setTotalExtraDays(0)
    setComment(null)
    setTotalTransport(0)
    setActiveStep(0);
    setSignatureBytes([])


  };

  const handleSubmit = () => {

    setLoading(true)

    var booking = { id: 0 }
    //Center 
    booking.Center = { id: selectedCenter.id }
    booking.IdCenter = selectedCenter.id;

    let arrival_hour = arrivalHour ? arrivalHour.split(':')[0] : 0
    let arrival_minute = arrivalHour ? arrivalHour.split(':')[1] : 0

    let departure_hour = departureHour ? departureHour.split(':')[0] : 0
    let departure_minute = departureHour ? departureHour.split(':')[1] : 0

    booking.ArrivalHour = dayjs(weeks[0].startDate).set('hour', arrival_hour).set('minute', arrival_minute).format("MM/DD/YYYY HH:mm:ss")
    booking.DepartureHour = dayjs(weeks[weeks.length - 1].endDate).set('hour', departure_hour).set('minute', departure_minute).format("MM/DD/YYYY HH:mm:ss")

    booking.Category = ageGroup;
    booking.Extras = extras;
    booking.Weeks = weeks;
    //Student 
    booking.StudentFirstName = firstName;
    booking.StudentLastName = lastName
    booking.StudentEmail = email
    booking.StudentIdCard = passport
    booking.StudentGender = gender
    booking.StudentNationality = nationality;
    booking.StudentBirthdate = dayjs(birthDate).format('MM/DD/YYYY');;
    booking.StudentMotherTongue = motherTongue;
    booking.StudentAdress = address;
    booking.StudentAdress2 = address2;
    booking.StudentAdress3 = address3;
    booking.StudentCountry = country;
    booking.StudentLocality = locality;
    booking.StudentZipcode = zip_code;
    booking.StudentPhone = phone;
    //Parents 
    booking.Contacts = [
      { Name: motherName, Email: motherEmail, Occupation: motherOccupation, Mobile: motherPhone },
      { Name: fatherName, Email: fatherEmail, Occupation: fatherOccupation, Mobile: fatherPhone }
    ];
    booking.FreeTimeGuard = unsupervisedFreeTime == "1" ? true : false;

    //Health
    booking.AsthmaOrBronchitis = asthmaOrBronchitis == "1" ? true : false;
    booking.AllergiesToKnownMedicines = allergiesToKnownMedicines == "1" ? true : false;
    booking.FitsFaintingBlack = fitsFaintingBlack == "1" ? true : false;
    booking.OtherAllergies = otherAllergies == "1" ? true : false;
    booking.TravelSickness = travelSickness == "1" ? true : false;
    booking.HeartCondition = heartCondition == "1" ? true : false;
    booking.BedwettingIncontinence = bedwettingIncontinence == "1" ? true : false;
    booking.SevereHeadaches = severeHeadaches == "1" ? true : false;
    booking.AnyMentalHealthProblems = anyMentalHealthProblems == "1" ? true : false;
    booking.Diabetes = diabetes == "1" ? true : false;
    booking.RegularMedication = regularMedication == "1" ? true : false;
    booking.RegularHospitalTreatment = regularHospitalTreatment == "1" ? true : false;
    booking.AnyMedicationPring = anyMedicationPring == "1" ? true : false;
    booking.AgreeNonPrescription = agreeNonPrescription == "1" ? true : false;
    booking.ArrangeMedicalTreatment = arrangeMedicalTreatment == "1" ? true : false;
    booking.AnythingElse = anythingElse == "1" ? true : false;
    booking.MedicalComment = moreDetails;
    booking.RoomingComment = roomingComment;

    //Transport
    booking.IdAirportDeparture = departureAirport;
    booking.IdAirportArrival = arrivalAirport;

    booking.DepartureFlightNumber = departureFlightNumber;
    booking.ArrivalFlightNumber = arrivalFlightNumber;

    booking.DepartureTerminal = departureTerminal;
    booking.ArrivalTerminal = arrivalTerminal

    booking.ArrivalUm = arrivalUmService == "1" ? true : false;
    booking.DepartureUm = departureUmService == "1" ? true : false;

    booking.ArrivalTransfert = arrivalTransfer == "1" ? true : false;
    booking.DepartureTransfert = departureTransfer == "1" ? true : false;

    booking.ArrivalComment = arrivalComment;
    booking.DepartureComment = departureComment;

    //Pricing
    booking.TotalUm = total_um;
    booking.TotalTransport = total_transport;
    booking.TotalJourney = total_journey;
    booking.TotalExtra = total_extra;
    booking.TotalExtraDays = total_extra_days;
    booking.TotalCommission = total_commission;
    booking.Total = total_journey + total_extra + total_transport + total_um + total_extra_days - total_discount - total_commission;
    booking.FinencialComment = comment;
    booking.totalDiscount = 0;
    booking.Payments = [];
    booking.Files = [];
    booking.idUser = currentUser ? currentUser.id : null;

    booking.visaSent = false;
    booking.PaymentConfirmationSent = false;
    booking.PaymentConfirmationDepositSent = false;
    booking.TransferInfoSent = false;
    booking.BookingConfirmationSent = false;
    booking.InvoiceSent = false;
    booking.CreditNoteSent = false;

    booking.profilePicture = profilePicture;
    booking.passportPicture = passportPicture;

    booking.StudentCountryName = countryName;
    booking.SignatureBytes = signatureBytes;

    setSendingBooking(true)
    dispatch(upsertBooking(booking))
      .then(() => {
        setLoading(false)
        setSendingBooking(false)
        toast.success(
          `Enrolment saved successfuly`,
          { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
        );
        return true;
      })
      .catch((error) => {
        setLoading(false)
        setActiveStep(6)
        toast.error(
          `An Error occured while saving the enrolment. Please try again later.`,
          { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
        );
        return false;
      });
  };


  useEffect(() => {
    handleWeeksChange(weeks);
  }, [ageGroup])

  function handleWeeksChange(weeks) {
    if (selectedCenter) {

      let totalJourney

      if (selectedCenter.currency == 1) {
        let supplement = 0
        if (weeks.filter((w) => w.id === 5).length > 0) {
          supplement += 700;
        }
        totalJourney = weeks.length * selectedCenter.pricePerWeek + supplement;
      }
      else {
        let pricePerWeek

        // Check if all training program prices are 0 or null
        const allPricesZero = !selectedCenter.trainingProgramPrice1 && !selectedCenter.trainingProgramPrice2 && 
                            !selectedCenter.trainingProgramPrice3 && !selectedCenter.trainingProgramPrice4;

        if (allPricesZero) {
          // Use center's default price if all training program prices are 0
          pricePerWeek = selectedCenter.pricePerWeek;
        } else {
          switch (ageGroup) {
            case 0:  // Little Explorers
              pricePerWeek = selectedCenter.trainingProgramPrice1
              break;
            case 1:  // New Adventurers
              pricePerWeek = selectedCenter.trainingProgramPrice2
              break;
            case 2:  // Rising Learners
              pricePerWeek = selectedCenter.trainingProgramPrice3
              break;
            case 3:  // Future Leaders
              pricePerWeek = selectedCenter.trainingProgramPrice4
              break;
            default:
              pricePerWeek = 0
              break;
          }
        }

        totalJourney = weeks.length * pricePerWeek
      }

      setTotalJourney(totalJourney)

      if (currentUser != null) {
        if (currentUser.commissionType == 1) {
          //Direct donc on ne fait rien
        } else {
          if (currentUser.commissionType != 4) { //Pré ou post (2-3)
            setTotalCommission(totalJourney * (currentUser.commissionPercentage / 100))
          } else { //Spécial price (4)
            setTotalJourney(weeks.length * (currentUser.pricePerWeek));
          }
        }
      }
    }

    setWeeks(weeks);
  }
  function handleExtrasChange(extras) {
    const sum = extras.reduce((accumulator, object) => {
      return accumulator + object.price;
    }, 0);
    setTotalExtra(sum)
    setExtras(extras);
  }


  function calculateTotalUMPrice(a, d) {
    if (a == 1 && d == 1) {
      setTotalUM(selectedCenter.umPrice * 2)
    } else if (a == 1 || d == 1) {
      setTotalUM(selectedCenter.umPrice)
    } else {
      setTotalUM(0)
    }
  }

  function handleArrivalUmChange(arrival_um) {
    calculateTotalUMPrice(arrival_um, departureUmService);
    setArrivalUmService(arrival_um);
  }
  function handleDepartureUmChange(departure_um) {
    calculateTotalUMPrice(arrivalUmService, departure_um);
    setDepartureUmService(departure_um);
  }


  function calculateTotalTransportPrice(a, d) {
    console.log(selectedCenter)
    if (a == 1 && d == 1) {
      setTotalTransport(selectedCenter.transferPrice * 2)
    } else if (a == 1 || d == 1) {
      setTotalTransport(selectedCenter.transferPrice)
    } else {
      setTotalTransport(0)
    }
  }

  function handleArrivalTransferChange(arrival_transfer) {
    calculateTotalTransportPrice(arrival_transfer, departureTransfer);
    setArrivalTransfer(arrival_transfer);
  }
  function handleDepartureTransferChange(departure_transfer) {
    calculateTotalTransportPrice(arrivalTransfer, departure_transfer);
    setDepartureTransfer(departure_transfer);
  }

  return (
    <div class="app-container">
      <Grid container spacing={2} sx={{}}>
        <Grid item xs={12} >
          <h1>Enrolment form</h1>
        </Grid>
        <Grid item xs={2} >
          <Paper elevation={3} display="flex" className="step-container">

            <Stepper activeStep={activeStep} orientation="vertical" sx={{ marginTop: 2 }}>
              {steps.map((step, index) => (
                <Step key={step.label}>
                  <StepButton onClick={handleStep(index)}>{step.label}</StepButton>
                </Step>
              ))}
            </Stepper>

          </Paper>
        </Grid>
        <Grid item xs={7}>
          {steps[activeStep] != null ? steps[activeStep].component : <></>}
          {activeStep === steps.length ? (
            sending_booking ?
              <>
                <Backdrop
                  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                  open={loading}
                  onClick={handleClose}>
                  <CircularProgress color="inherit" />
                </Backdrop>
              </> :
              <>
                <Paper elevation={3} display="flex" className={"step-container"}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} >
                      <Typography fontSize={20} fontWeight={"bold"} mb={1}>
                        Thank you for your registration. You will be receiving very soon a confirmation on your email address
                      </Typography>
                    </Grid>
                  </Grid>
                  <img
                    src={`${process.env.PUBLIC_URL}/plane.jpg`}
                    alt="plane"
                    width={'100%'}
                    className="plane" />
                </Paper>
                <Grid container direction="row" justifyContent="center" alignItems="center" marginTop={3}>
                  <Button variant="contained" onClick={handleReset} sx={{ width: '50%' }} endIcon={<RestartAltIcon />} >
                    New Booking
                  </Button>
                </Grid>
              </>
          ) : (
            <>
              <Grid container
                direction="row"
                justifyContent="center"
                alignItems="center">
                <Grid item xs={3} sx={{ mt: 1 }}>
                  <Button
                    variant="outlined"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    startIcon={<UndoIcon />}
                    sx={{ mt: 1, mr: 1, minwidth: 3, width: '100%', fontWeight: "bold" }}>
                    Back
                  </Button>
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={3}>
                  <Button
                    variant="contained"
                    onClick={handleNext}
                    endIcon={<RedoIcon />}
                    sx={{ mt: 1, mr: 1, minwidth: 3, width: '100%', color: "white", fontWeight: "bold" }}>
                    {activeStep === steps.length - 1 ? "Validate the enrolment" : "Next"}
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
        {activeStep != steps.length ?
          <Grid item xs={3}>
            <PricingDetailsArray
              center={selectedCenter}

              total_discount={total_discount} setTotalDiscount={setTotalDiscount}
              total_commission={total_commission} setTotalCommission={setTotalCommission}

              total_um={total_um} setTotalUM={setTotalUM}
              total_transport={total_transport} setTotalTransport={setTotalTransport}
              total_journey={total_journey} setTotalJourney={setTotalJourney}
              total_extra={total_extra} setTotalExtra={setTotalExtra}
              total_extra_days={total_extra_days} setTotalExtraDays={setTotalExtraDays}
              total={total} setTotal={setTotal}
              balance={balance} setBalance={setBalance}
              edit_mode={false}
            />
          </Grid> : <></>}
      </Grid>
    </div>
  );
};

export default Booking;
